import styled from '@emotion/styled';
import { DatePicker } from '@material-ui/pickers';
import moment from 'moment-timezone';
import React from 'react';

type Props = {
  value: { start: moment.Moment; end: moment.Moment };
  onChange: (nextValue: { start: moment.Moment; end: moment.Moment }) => void;
  startWeeksOnMonday?: boolean;
};

const DateRangePickerContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DateRangePicker: React.FC<Props> = ({ value, onChange }) => {
  return (
    <DateRangePickerContainer>
      <DatePicker
        autoOk
        variant="static"
        openTo="date"
        value={value.start}
        clearable={false}
        onChange={(m) => onChange({ ...value, start: m! as any })}
      />
      <DatePicker
        autoOk
        variant="static"
        openTo="date"
        value={value.end}
        clearable={false}
        onChange={(m) => onChange({ ...value, end: m! as any })}
      />
    </DateRangePickerContainer>
  );
};
